
const praias = [
  {
    id: 1,
    name: 'Prainha do Caniçal',
    type: 'Praia de Areia Negra',
    distance: '10 min de carro',
    description: 'A única praia de areia natural da Madeira. Areia negra vulcânica única, águas calmas e cristalinas. Ideal para famílias e snorkel.',
    image: 'https://public.readdy.ai/ai/img_res/aa557936ee0bc41ee0e09c5c4f3f198b.jpg',
    tags: ['Areia Natural', 'Snorkel', 'Família'],
    highlight: 'Única areia natural',
    highlightColor: 'bg-amber-500',
  },
  {
    id: 2,
    name: 'Piscinas Naturais do Porto Moniz',
    type: 'Piscinas Vulcânicas',
    distance: '1h de carro',
    description: 'Piscinas naturais formadas por rochas vulcânicas com água do oceano. Uma das atrações mais icónicas da Madeira. Imperdível!',
    image: 'https://readdy.ai/api/search-image?query=Porto%20Moniz%20natural%20volcanic%20rock%20pools%20Madeira%20island%2C%20crystal%20clear%20ocean%20water%20in%20natural%20lava%20pools%2C%20dramatic%20black%20volcanic%20rocks%2C%20people%20swimming%2C%20stunning%20coastal%20scenery%2C%20turquoise%20water%2C%20iconic%20Madeira%20attraction&width=700&height=450&seq=praia2&orientation=landscape',
    tags: ['Piscinas Naturais', 'Ícone da Madeira', 'Fotografia'],
    highlight: 'Imperdível',
    highlightColor: 'bg-sea-blue',
  },
  {
    id: 3,
    name: 'Praia de Machico',
    type: 'Praia de Areia Dourada',
    distance: '5 min de carro',
    description: 'A praia mais próxima dos apartamentos! Areia dourada importada, águas tranquilas na baía de Machico. Perfeita para relaxar e nadar.',
    image: 'https://readdy.ai/api/search-image?query=Machico%20beach%20Madeira%20island%20golden%20sand%20bay%2C%20calm%20turquoise%20water%2C%20surrounded%20by%20green%20mountains%2C%20beach%20umbrellas%2C%20sunny%20vacation%20day%2C%20beautiful%20bay%2C%20relaxing%20beach%20scene%2C%20coastal%20town%20in%20background&width=700&height=450&seq=praia3&orientation=landscape',
    tags: ['Areia Dourada', 'Águas Calmas', 'A 5 min'],
    highlight: 'Mais próxima',
    highlightColor: 'bg-nature-green',
  },
  {
    id: 4,
    name: 'Ponta de São Lourenço',
    type: 'Reserva Natural',
    distance: '15 min de carro',
    description: 'A ponta mais oriental da Madeira. Paisagem lunar com falésias dramáticas sobre o oceano. Trilho de 9km com vistas de tirar o fôlego.',
    image: 'https://readdy.ai/api/search-image?query=Ponta%20de%20Sao%20Lourenco%20Madeira%20eastern%20tip%2C%20dramatic%20volcanic%20cliffs%20over%20Atlantic%20ocean%2C%20rugged%20lunar%20landscape%2C%20hiking%20trail%2C%20panoramic%20ocean%20views%2C%20unique%20geological%20formations%2C%20wild%20nature%2C%20breathtaking%20scenery&width=700&height=450&seq=praia4&orientation=landscape',
    tags: ['Trilho', 'Reserva Natural', 'Fotografia'],
    highlight: 'Vista Épica',
    highlightColor: 'bg-rose-500',
  },
];

const PraiasSection = () => {
  return (
    <section id="praias" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sea-blue text-xs font-semibold uppercase tracking-widest mb-3">Sol & Mar</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Praias & <span className="font-serif italic text-sea-blue">Piscinas Naturais</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            Da areia negra vulcânica às piscinas naturais esculpidas pela lava — a Madeira surpreende com paisagens costeiras únicas no mundo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {praias.map((praia) => (
            <div
              key={praia.id}
              className="group relative rounded-3xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={praia.image}
                  alt={praia.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <span className={`absolute top-4 left-4 ${praia.highlightColor} text-white text-xs font-semibold px-3 py-1 rounded-full`}>
                  {praia.highlight}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <p className="text-white/70 text-xs font-medium uppercase tracking-wide mb-1">{praia.type}</p>
                  <h3 className="text-white text-xl font-semibold mb-2">{praia.name}</h3>
                  <div className="flex items-center gap-1.5 text-white/80 text-sm">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-map-pin-line"></i>
                    </div>
                    {praia.distance}
                  </div>
                </div>
              </div>
              <div className="bg-white p-6">
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{praia.description}</p>
                <div className="flex flex-wrap gap-2">
                  {praia.tags.map((tag, i) => (
                    <span key={i} className="text-xs bg-stone-100 text-gray-600 px-3 py-1 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PraiasSection;
